export const DESTINATIONS = [
  { name: "Maldives", country: "Maldives", tag: "Beach Paradise", size: "large",
    image: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" },
  { name: "Paris", country: "France", tag: "City of Light", size: "small",
    image: "https://images.pexels.com/photos/16823629/pexels-photo-16823629.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { name: "Tokyo", country: "Japan", tag: "Neon Nights", size: "small",
    image: "https://images.pexels.com/photos/35072454/pexels-photo-35072454.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { name: "New York", country: "United States", tag: "The Big Apple", size: "small",
    image: "https://images.unsplash.com/photo-1547841243-eacb14453cd9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { name: "Dubai", country: "United Arab Emirates", tag: "Luxury & Desert", size: "small",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { name: "London", country: "United Kingdom", tag: "Timeless Icon", size: "medium",
    image: "https://images.unsplash.com/photo-1646750932420-5a6a1d9076a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { name: "Bangkok", country: "Thailand", tag: "Temples & Street Food", size: "medium",
    image: "https://images.unsplash.com/photo-1508009603885-50cf7c579365?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
];
